import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../config/firebase";

export function useStream(streamId: string) {
  const [matchId, setMatchId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!streamId) return;

    const streamRef = doc(db, "streams", streamId);

    const unsubscribe = onSnapshot(
      streamRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setMatchId(data.matchId);
          setError(null);
        } else {
          setError(`Stream ${streamId} not found.`);
          setMatchId(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Stream subscription error:", err);
        setError("Failed to subscribe to stream.");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [streamId]);

  return { matchId, loading, error };
}
